import { IServicePackages } from '../../../../../redux/reducers';
import { IPublishOptionSchema } from '../../internalTypes';
import { getOptionId } from '../getOptionId';

export function mapPackages(packages: IPublishOptionSchema[]): IServicePackages {
  return packages.reduce((acc, servicePackage) => {
    const packageId = getOptionId(servicePackage);

    acc[packageId] = {
      ...servicePackage,
      id: packageId,
      price: parseFloat(servicePackage.price),
      marketingPrice: parseFloat(servicePackage.marketingPrice),
    };

    return acc;
  }, {} as IServicePackages);
}
